import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import CustomTable from "../../common/CustomTable";
import { StyledTablePagination, useStyles } from '../styles/index.style';
import {useDigitalPR} from '../hooks/useDigitalPR';
import TableFilters from './TableFilters';
import { storeContext } from '../../provider/Provider';
import SkeletonWrapper from '../../common/SkeletonWrapper';
import MobileTitle from '../../../customUI/MobileTitle';
import VideoPopup from '../../common/VideoPopup';
import AppliedFilters from './AppliedFilters';
import TableActions from './TableActions';

const PRTableFullView = () => {
   const classes = useStyles();
   const { state } = useContext(storeContext);
   const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
   const { 
      handleCampaignsPageChange, 
      handleCampaignsPerPageChange, 
      columns, 
      style, 
      childStyle, 
      childColumns,
      currentFilters,
      onCampaignFiltersChange,
      closeVideoPopup,
      getRowStyle,
    } = useDigitalPR();

   return (
      <Box className={isPhone ? '' : classes.wrapper}>
         <Box className={isPhone ? '' : classes.card}>
            <Box className={isPhone ? '' : classes.card__wrapper}>
               <Box display="flex" flexWrap="wrap" justifyContent="space-between">
                  {!isPhone? 
                  (<Box className={classes.card_title}>Campaigns</Box>):
                  (<MobileTitle title="Campaigns" />)}
                  <TableActions onFilterChange={onCampaignFiltersChange} />
               </Box>
               <AppliedFilters />
               <TableFilters filters={currentFilters} onFilterChange={onCampaignFiltersChange} />
               <SkeletonWrapper condition={state.digitalPR.historicCampaignsLoading}>
                  <>
                     <CustomTable 
                        data={state.digitalPR.campaignList} 
                        columns={columns} 
                        style={style} 
                        childColumns={childColumns} 
                        childStyle={childStyle}
                        rowStyle={getRowStyle} />
                     <Box display="flex" justifyContent="end" pb={5}>
                        <StyledTablePagination
                           rowsPerPageOptions={[10, 25, 50]}
                           component="div"
                           count={state.digitalPR.totalCampaigns}
                           rowsPerPage={state.digitalPR.campaignFilters.perPage}
                           page={state.digitalPR.campaignFilters.page}
                           onPageChange={handleCampaignsPageChange}
                           onRowsPerPageChange={handleCampaignsPerPageChange}
                           labelRowsPerPage="Rows:"
                        />
                     </Box>
                  </>
               </SkeletonWrapper>
            </Box>
         </Box>
         {state.digitalPR.isVideoOpen && <VideoPopup isOpen={state.digitalPR.isVideoOpen} videoUrl={state.digitalPR.videoUrl} onClose={closeVideoPopup} />}
      </Box>
   )
}

export default PRTableFullView;